import store from '../redux/configureStore';
import axios from 'axios';

store.subscribe(listener);

function select(state) {
    const languages = state.localize.languages;
    let currentLang = 'fr';

    languages.filter(lang => {
        return lang.active === true
    }).map(lang => {
        currentLang = lang.code;
    });

    return currentLang;
}

function listener() {
    let currentLang = select(store.getState());

    axios.defaults.headers.common['Site-Lang'] = currentLang;
}

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

export default instance;


// WEBPACK FOOTER //
// ./src/app/api/axios.js